import { createContext, useReducer } from "react";

export const AppContext = createContext(null);

function reducer(state, action) {
  switch (action.type) {
    case "updateModalState":
      return {
        ...state,
        openModal: !state.openModal,
        openedModal: !!state.openModal ? null : state.openedModal,
        pendingAction: action.pendingAction || null,
      };
    case "updateModalType":
      return {
        ...state,
        openedModal: {
          openedModal: action.openedModal,
          title: action.title,
          data: action.data,
        },
        openModal: !state.openModal,
      };
    case "resetPendingAction":
      return {
        ...state,
        pendingAction: null,
      };
    case "updateLoaderState":
      return {
        ...state,
        loaderState: action.payload,
      };
    case "updateNotification":
      return {
        ...state,
        notification: action.payload,
      };
    case "updateCurrentPlayerId":
      return {
        ...state,
        currentPlayerId: action.payload,
      };
    case "updateAppId":
      return {
        ...state,
        currentAppId: action.payload,
      };
    case "updateCategory":
      return {
        ...state,
        category: action.payload,
      };
    default:
      return state;
  }
}

const AppContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {
    openModal: false,
    openedModal: null,
    loaderState: false,
    pendingAction: null,
    notification: { show: false, type: "", message: "" },
    currentPlayerId: null,
    currentAppId: null,
    category: "",
    updateModalState: (pendingAction = null) =>
      dispatch({ type: "updateModalState", pendingAction }),
    resetPendingAction: () => dispatch({ type: "resetPendingAction" }),
    updateModalType: (openedModal, title = null, data = "null") =>
      dispatch({ type: "updateModalType", openedModal, title, data }),
    updateLoaderState: (loaderState) =>
      dispatch({ type: "updateLoaderState", payload: loaderState }),
    updateNotificationState: (payload) =>
      dispatch({ type: "updateNotification", payload }),
    updateCurrentPlayerId: (payload) =>
      dispatch({ type: "updateCurrentPlayerId", payload }),
    updateAppId: (payload) => {
      dispatch({ type: "updateAppId", payload });
    },
    updateCategory: (payload) => {
      dispatch({ type: "updateCategory", payload });
    },
  });
  return <AppContext.Provider value={state}>{children}</AppContext.Provider>;
};

export default AppContextProvider;
